import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import BrandPage from "@/pages/BrandPage";
import CategoryPage from "@/pages/CategoryPage";
import Contact from "@/pages/Contact";
import ExpertHelp from "@/pages/ExpertHelp";
import Landing from "@/pages/Landing";
import DynamicPage from "@/pages/DynamicPage";
import NotFound from "@/pages/NotFound";

// Heavy / non-landing routes are code-split so the initial bundle (and every
// ad landing page) loads fast.
const ChatPage = lazy(() => import("@/pages/ChatPage"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("@/pages/PaymentCancel"));
const Track = lazy(() => import("@/pages/Track"));
const Admin = lazy(() => import("@/pages/Admin"));
const Specialist = lazy(() => import("@/pages/Specialist"));

const RouteFallback = () => (
  <div className="flex min-h-[50vh] items-center justify-center font-mono text-sm text-muted">Loading…</div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/brand/:slug" element={<BrandPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/how-it-works" element={<DynamicPage slug="how-it-works" />} />
              <Route path="/expert-help" element={<ExpertHelp />} />
              <Route path="/get-help" element={<Landing />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/track/:id" element={<Track />} />
              <Route path="/about" element={<DynamicPage slug="about" />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<DynamicPage slug="privacy" />} />
              <Route path="/terms" element={<DynamicPage slug="terms" />} />
              <Route path="/refunds" element={<DynamicPage slug="refunds" />} />
              <Route path="/disclaimer" element={<DynamicPage slug="disclaimer" />} />
              <Route path="/p/:slug" element={<DynamicPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
            <Route path="/specialist" element={<Specialist />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
